<script>
export default {
  name: "ModelForm",
  props: {
    texturesLimit: {
      type: Number,
      default: 1,
    },
    textureCount: {
      type: Number,
      default: [],
    },
  },
  created() {
    if (this.textures) this.fields = this.textures
    if (this.textureCount > 0) {
      this.textureCountLocal = this.textureCount
    } else {
      this.addField()
    }
  },
  data() {
    return {
      file_input_model: {},
      fields: [],
      textureCountLocal: 0,
    }
  },
  computed: {
    isLimit() {
      return this.textureCountLocal < this.texturesLimit
    },
    fieldItems() {
      return this.texturesLimit - 1 > this.fields.length
    },
  },
  methods: {
    inputFileChange(ref) {
      let files
      let refs = this.$refs["file_input_" + ref]
      if (refs.length) {
        files = refs[0].files
      } else if (refs) {
        files = refs.files
      } else {
        files = {}
      }
      if (files.length) {
        this.updateFieldFile(ref, files[0])
      } else if (files) {
        this.updateFieldFile(ref, files)
      } else {
        this.updateFieldFile(ref, {})
        this.$refs[`file_name_${ref}`].placeholder = "Выберите файл..."
      }
    },
    updateFieldFile(ref, file) {
      if (this.$refs[`file_name_${ref}`]) {
        this.$refs[`file_name_${ref}`].placeholder = file.name ?? "Выберите файл..."
      }
      if (this.$refs[`file_guid_${ref}`]) {
        this.$refs[`file_guid_${ref}`].value = ""
      }
      for (const fieldsKey in this.fields) {
        if (this.fields[fieldsKey].uuid === ref) {
          this.fields[fieldsKey].file = file
          if (file) {
            this.fields[fieldsKey].preview = URL.createObjectURL(file)
          } else {
            this.fields[fieldsKey].preview = null
          }
        }
      }
    },
    fileUpload(ref) {
      let refs = this.$refs["file_input_" + ref]
      if (refs && refs.length) {
        refs[0].click()
      } else {
        refs.click()
      }
    },
    addField() {
      this.fields.push({
        uuid: this.newUuid(),
        preview: null,
        file: {},
      })
      this.textureCountLocal++
    },
    removeField(uuid) {
      this.fields = this.fields.filter((item) => item.uuid !== uuid)
      this.textureCountLocal--
    },
    removeFieldOld(uuid) {
      this.textureCountLocal--
    },
    newUuid() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0,
          v = c === "x" ? r : (r & 0x3) | 0x8
        return v.toString(16)
      })
    },
    modelDelete(url) {
      window.location = url
    },
  },
}
</script>
